module.exports = __webpack_public_path__ + "img/06_Die_hast_Fragen.0879cfcc.svg";